import { useEffect, useState } from "react";
import { http, FALLBACK_TRACKS } from "@/lib/api";
import { Reveal, SectionLabel } from "./Reveal";
import { ReleaseCard } from "./ReleaseCard";

export function Releases() {
  const [tracks, setTracks] = useState(FALLBACK_TRACKS);
  useEffect(() => {
    http.get("/tracks").then((r) => {
      if (Array.isArray(r.data) && r.data.length) setTracks(r.data);
    }).catch(() => {});
  }, []);
  return (
    <section id="releases" data-testid="releases-section" className="relative bg-[var(--ink-2)] py-28 md:py-40">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal><SectionLabel index="02">Releases</SectionLabel></Reveal>
        <div className="mt-12 flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <Reveal>
            <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.9] sm:text-6xl lg:text-8xl">
              Music <span className="font-serif-i font-normal normal-case text-[var(--gold)]">release.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="max-w-sm">
            <p className="text-sm leading-relaxed text-[var(--stone)] md:text-base">
              Listen to a preview of every production and buy the full-quality file: the download starts right after payment.
            </p>
          </Reveal>
        </div>
        <div data-testid="releases-section-grid" className="mt-16 grid gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-4">
          {tracks.map((t, i) => <ReleaseCard key={t.id} track={t} index={i} />)}
        </div>
      </div>
    </section>
  );
}
